import portfolio from '@/data/portfolio'

const state = {
  // = data
  all: [],
}

const getters = {
  // = computed properties
  // allProjects(state, getters, rootState) {
  //   console.log(rootState.projects);
  //   return state.projects;
  // },
  allProjects: state => state.all,
  // getProject: (state) => slug => {
  //   console.log(slug);
  //   state.projects.filter(project => project.slug === slug),
  // },
  getProjectWithLimit: state => (limit, offset = 0) =>
    state.all.slice(offset, limit + offset),
  getProjectBySlug: state => slug =>
    state.all.filter(project => project.slug === slug)[0],
  getProjectsById: state => ids => {
    const projects = []
    if (state.all.length > 0) {
      ids.forEach(id => {
        const project = state.all.filter(
          localProject => localProject.id === id
        )[0]
        projects.push(project)
      })
    }
    return projects
  },
  getFeaturedProject: state =>
    state.all.filter(project => project.featured === true)[0],
}

const actions = {
  // = Methods
  fetchProjects({ commit }) {
    return new Promise(resolve => {
      // make the call
      portfolio.getProjects(projects => {
        commit('setProjects', projects)
        resolve()
      })
    })
  },
}

const mutations = {
  // = responsible for setting and updating the state
  setProjects(state, projects) {
    // update projects
    state.all = projects
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
